import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style/style.scss";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/width.scss";

import Login from "./Screen/Auth/Login";
import Register from "./Screen/Auth/Register";
import Forgot from "./Screen/Auth/Forgot";
import CreatePassword from "./Screen/Auth/CreatePassword";
import Layout from "./Screen/Layout/Layout";
import Home from "./Screen/Home/Home";
import Profile from "./Screen/Profile/Profile";
import Links from "./Screen/Links/Links";
import WinningHistory from "./Screen/WinningHistory/WinningHistory";
import ReferFriends from "./Screen/ReferFriends/ReferFriends";
import Wallet from "./Screen/Wallet/Wallet";
import PurchaseReport from "./Screen/PurchaseReport/PurchaseReport";
import WinningReport from "./Screen/WinningReport/WinningReport";
import Notifications from "./Screen/Notification/Notifications";
import RechargeHistory from "./Screen/RechargeHistory/RechargeHistory";
import MyReport from "./Screen/MyReport/MyReport";
import Recharge from "./Screen/Recharge/Recharge";
import Withdraw from "./Screen/Withdraw/Withdraw";
import DailyResult from "./Screen/DailyResult/DailyResult";
import PriceList from "./Screen/PriceList";
import Cart from "./Screen/Cart";
import LotteryGameScreen from "./Screen/LotteryGameScreen";
import HttpClient from "./Services/HttpClient";

const AppRoutes = () => {
  // Restore token
  let tokenUser = localStorage.getItem("token");
  let persistToken = sessionStorage.getItem("token");
  let token = tokenUser || persistToken;

  // Auto Logout Check
  useEffect(() => {
    const lastClosedTime = localStorage.getItem("lastClosedTime");

    if (lastClosedTime) {
      const lastTime = new Date(parseInt(lastClosedTime));
      const now = new Date();

      const minutesDifference = (now - lastTime) / (1000 * 60);

      if (minutesDifference > 10) {
        // More than 10 min → logout
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        token = null;
      }
    }
  }, []);

  // Save close time on browser close
  useEffect(() => {
    const handleTabClose = () => {
      localStorage.setItem("lastClosedTime", Date.now().toString());
    };

    window.addEventListener("beforeunload", handleTabClose);
    return () => window.removeEventListener("beforeunload", handleTabClose);
  }, []);

  // Apply token to Axios
  if (token) {
    HttpClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  return (
    <Routes>
      <Route path="/" element={token ? <Navigate to="/home" /> : <Login />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/create-password" element={<CreatePassword />} />
      <Route path="/register" element={<Register />} />
      <Route element={<Layout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/links" element={<Links />} />
        <Route path="/winning-history" element={<WinningHistory />} />
        <Route path="/refer-friends" element={<ReferFriends />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/my-report" element={<MyReport />} />
        <Route path="/purchase-report" element={<PurchaseReport />} />
        <Route path="/winning-report" element={<WinningReport />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/recharge-history" element={<RechargeHistory />} />
        <Route path="/recharge" element={<Recharge />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/daily-result" element={<DailyResult />} />
        <Route path="/price-list" element={<PriceList />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/lottery-game/:name" element={<LotteryGameScreen />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
